import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import nl from "./locales/nl.json";
import fr from "./locales/fr.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGS = ["nl", "fr", "en"] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: "nl",
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    nonExplicitSupportedLngs: true, // nl-BE -> nl
    returnNull: false, // t() returns "" not null → string-typed
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator", "htmlTag"], caches: ["localStorage"] },
  });

// Keep <html lang> in sync for a11y/SEO.
(i18n as any).on("languageChanged", (lng: string) => {
  document.documentElement.lang = lng;
});

export default i18n;
